import React, { useMemo } from "react";
import { Col, Table, Container } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";

const dash = (value) => (value != null && value !== "" ? value : "—");

const formatAmount = (amount) => {
  const n = Number(amount);
  if (!Number.isFinite(n) || n <= 0) return "—";
  return `INR ${n}`;
};

const HolidayBookingDetails = ({ booking }) => {
  const bookingId = booking?.bookingId;
  const verticalData = useMemo(() => {
    const row = booking || {};
    const duration =
      row.totalDays > 0
        ? `${row.totalDays} days / ${row.totalNights || 0} nights`
        : null;
    const rows = [
      { attribute: "Reference ID", value: dash(row.bookingRef) },
      { attribute: "Package Name", value: dash(row.packageName) },
      { attribute: "Travel Date", value: dash(row.travelDate) },
      { attribute: "Route", value: dash(row.route) },
      { attribute: "Travellers", value: dash(row.travellers) },
      { attribute: "Amount", value: formatAmount(row.amount) },
      { attribute: "Booking Status", value: dash(row.status) },
      { attribute: "Customer Name", value: dash(row.name) },
      { attribute: "Phone Number", value: dash(row.phone) },
    ];
    if (duration) {
      rows.splice(4, 0, { attribute: "Duration", value: duration });
    }
    return rows;
  }, [bookingId, booking?.bookingRef, booking?.packageName, booking?.travelDate, booking?.route, booking?.travellers, booking?.amount, booking?.status, booking?.name, booking?.phone, booking?.totalDays, booking?.totalNights]);

  return (
    <Container fluid style={{ marginTop: "5vh" }}>
      <Col lg={12} md={12} className={classes.Response2}>
        <Table striped bordered hover>
          <tbody>
            {verticalData.map((data, key) => (
              <tr key={key}>
                <td style={{ width: "35%" }}>{data.attribute}</td>
                <td style={{ width: "65%" }}>{data.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Col>
    </Container>
  );
};

export default HolidayBookingDetails;
